"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_TIMEZONE = exports.LOCATION_TIMEZONE_MAP = exports.SITE_ID_LOCATION_MAP = void 0;
exports.getTimezoneByLocation = getTimezoneByLocation;
exports.getFrontendSiteId = getFrontendSiteId;
exports.resolveFrontendLocation = resolveFrontendLocation;
/**
 * 展业地区通用映射
 *
 * 单一数据源：站点 ID / 展业地区 / IANA 时区的映射统一在此维护，
 * 供后端（@ark/env）与前端（@ark/dayjs/frontend）复用，避免重复定义。
 */
const enum_1 = require("../enum");
/**
 * 站点 ID 到展业地区的映射。
 *
 * 说明：
 * - CN(1) / CN_FINANCE(7) 归属香港展业时区，统一映射为 HK。
 * - TH(10) 对应泰国展业，映射为 TH（时区 Asia/Bangkok）。
 */
exports.SITE_ID_LOCATION_MAP = {
    [enum_1.SiteId.CN]: enum_1.BusinessLocation.HK,
    [enum_1.SiteId.US]: enum_1.BusinessLocation.US,
    [enum_1.SiteId.SG]: enum_1.BusinessLocation.SG,
    [enum_1.SiteId.AU]: enum_1.BusinessLocation.AU,
    [enum_1.SiteId.JP]: enum_1.BusinessLocation.JP,
    [enum_1.SiteId.HK]: enum_1.BusinessLocation.HK,
    [enum_1.SiteId.CN_FINANCE]: enum_1.BusinessLocation.HK,
    [enum_1.SiteId.MY]: enum_1.BusinessLocation.MY,
    [enum_1.SiteId.CA]: enum_1.BusinessLocation.CA,
    [enum_1.SiteId.TH]: enum_1.BusinessLocation.TH,
};
/**
 * 展业地区与 IANA 时区映射。
 *
 * 时区说明：
 * - HK 香港：Asia/Hong_Kong (UTC+8)
 * - SG 新加坡：Asia/Singapore (UTC+8)
 * - AU 澳大利亚：Australia/Sydney (UTC+10/+11，有夏令时)
 * - JP 日本：Asia/Tokyo (UTC+9)
 * - CA 加拿大：America/New_York (UTC-5/-4，有夏令时，东部时区)
 * - MY 马来西亚：Asia/Kuala_Lumpur (UTC+8)
 * - US 美国：America/New_York (UTC-5/-4，有夏令时，东部时区)
 * - NZ 新西兰：Pacific/Auckland (UTC+12/+13，有夏令时)
 * - TH 泰国：Asia/Bangkok (UTC+7)
 */
exports.LOCATION_TIMEZONE_MAP = {
    [enum_1.BusinessLocation.HK]: 'Asia/Hong_Kong',
    [enum_1.BusinessLocation.SG]: 'Asia/Singapore',
    [enum_1.BusinessLocation.AU]: 'Australia/Sydney',
    [enum_1.BusinessLocation.JP]: 'Asia/Tokyo',
    [enum_1.BusinessLocation.CA]: 'America/New_York',
    [enum_1.BusinessLocation.MY]: 'Asia/Kuala_Lumpur',
    [enum_1.BusinessLocation.US]: 'America/New_York',
    [enum_1.BusinessLocation.NZ]: 'Pacific/Auckland',
    [enum_1.BusinessLocation.TH]: 'Asia/Bangkok',
};
/**
 * 默认时区（无法确定展业地区时使用），默认使用香港时区。
 */
exports.DEFAULT_TIMEZONE = 'Asia/Hong_Kong';
/**
 * 根据展业地区获取对应的 IANA 时区。
 */
function getTimezoneByLocation(location) {
    return exports.LOCATION_TIMEZONE_MAP[location];
}
/**
 * 读取宿主（Fego）注入的 window._params.siteId。
 *
 * 前端展业地区/时区的唯一入参来源，缺失时返回 undefined。
 */
function getFrontendSiteId() {
    return globalThis._params?.siteId;
}
/**
 * 从宿主注入的 window._params.siteId 解析展业地区。
 *
 * 前端地区解析的单一入口，供 @ark/web-api、@ark/dayjs/frontend 等复用。
 * 缺失或无法映射时返回 undefined，由调用方决定抛错或兜底。
 */
function resolveFrontendLocation() {
    const siteId = getFrontendSiteId();
    if (siteId === undefined)
        return undefined;
    return exports.SITE_ID_LOCATION_MAP[siteId];
}
